export default __webpack_public_path__ + "static/media/robot.cf949d49.png";